import React, { FC } from 'react'

import { Modal, Txt, Icon, Tooltip } from 'src/components/atoms'
import { UsersBulkAssign } from 'src/components/organisms'

type Props = {
  targetUserIds: number[]
  isExternal: boolean
  isOpen: boolean
  onClose: () => void
  afterAssigned?: () => void
}

export const UsersBulkAssignModal: FC<Props> = ({
  targetUserIds,
  isExternal,
  isOpen,
  onClose,
  afterAssigned,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      enabledMainContentOverflow={false}
      canCloseClickOuter={false}
      maxWidth="md"
      headerInner={
        <div className="tw-px-s1">
          <div className="tw-full-justify">
            <div className="tw-flex tw-items-center">
              <Icon
                size="--r1"
                path="plus/soft/line"
                className="tw-accent-standardText-secondary"
              />
              <Txt sizeType="l" className="tw-ml-r-3 tw-font-bold">
                プロジェクト追加
              </Txt>
            </div>
            <Tooltip text="選択したユーザーへプロジェクトがまとめて追加されます。" placement="top">
              <div />
            </Tooltip>
          </div>
        </div>
      }
    >
      <div className="tw-w-[56.14rem] tw-p-s2">
        <UsersBulkAssign
          targetUserIds={targetUserIds}
          isExternal={isExternal}
          onCancel={onClose}
          afterAssigned={afterAssigned}
        />
      </div>
    </Modal>
  )
}
